import React from 'react';
import { FaGraduationCap, FaMapMarkerAlt, FaCalendarAlt, FaTrophy } from 'react-icons/fa';
import './Education.css';

const Education = () => {
  const education = [
    {
      degree: "Bachelor of Technology (B.Tech) Computer Science & Engineering",
      institution: "ABES INSTITUTE OF TECHNOLOGY",
      period: "07/2019 - 07/2023",
      location: "Ghaziabad, Uttar Pradesh",
      score: "SGPA: 8.4/10",
      achievements: ["Dean's List", "Technical Project Excellence", "Academic Merit"]
    },
    {
      degree: "Senior Secondary School (10+2)",
      institution: "PRIYANKA MODERN SCHOOL",
      period: "07/2018 - 07/2019",
      location: "Dhampur, Uttar Pradesh",
      score: "PCM %: 79/100",
      achievements: ["Science Stream Excellence", "Mathematics Proficiency"]
    }
  ];

  return (
    <section id="education" className="education">
      <div className="container">
        <h2 className="section-title">Education & Achievements</h2>
        
        <div className="education-grid">
          {education.map((edu, index) => (
            <div key={index} className="education-item">
              <div className="education-header">
                <div className="education-icon">
                  <FaGraduationCap />
                </div>
                <div className="education-info">
                  <h3>{edu.degree}</h3>
                  <h4>{edu.institution}</h4>
                </div>
                <div className="education-score">
                  <FaTrophy className="trophy-icon" />
                  <span>{edu.score}</span>
                </div>
              </div>
              
              <div className="education-meta">
                <div className="meta-item">
                  <FaCalendarAlt className="icon" />
                  <span>{edu.period}</span>
                </div>
                <div className="meta-item">
                  <FaMapMarkerAlt className="icon" />
                  <span>{edu.location}</span>
                </div>
              </div>
              
              <div className="education-achievements">
                <h5>Key Achievements:</h5>
                <ul>
                  {edu.achievements.map((achievement, achIndex) => (
                    <li key={achIndex}>{achievement}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
